import { ReactNode } from "react";
import { ThemeProvider } from "styled-components";
import { theme } from "@cdkglobal/radial";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FFContextProvider } from "@harnessio/ff-react-client-sdk";

import { UIStateProvider } from "../contexts/UIStateContext";
import { UserProvider } from "../contexts/UserContext";
import { LocaleContextProvider } from "../contexts/LocaleContext";
import IntlSetup from "../IntlSetup";
import AuthProvider from "./AuthProvider";
import { getHarnessFlag } from "../utils";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 15 * 1000,
    },
  },
});

const AppProviders = ({
  children,
}: Readonly<{
  children: ReactNode;
}>): JSX.Element => {
  return (
    <FFContextProvider {...getHarnessFlag()}>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <QueryClientProvider client={queryClient}>
            <UIStateProvider>
              <UserProvider>
                <LocaleContextProvider>
                  <IntlSetup>{children}</IntlSetup>
                </LocaleContextProvider>
              </UserProvider>
            </UIStateProvider>
          </QueryClientProvider>
        </ThemeProvider>
      </AuthProvider>
    </FFContextProvider>
  );
};

export default AppProviders;
